import { createSlice } from '@reduxjs/toolkit'

const engagementPromoSlice = createSlice({
  name: 'engagementPromo',
  initialState: {
    highCandidateEngagementProVisible: false,
    secondJobAttemptPremiumVisible: false,
  },
  reducers: {
    showHighCandidateEngagementPro: (state) => {
      state.highCandidateEngagementProVisible = true
    },
    showSecondJobAttemptPremium: (state) => {
      state.secondJobAttemptPremiumVisible = true
    },
  },
  extraReducers: (builder) => {
    //Clear data after user logout so the next session loads eligibility from the API
    builder.addCase('auth/LogOut', (state) => {
      state.highCandidateEngagementProVisible = false
      state.secondJobAttemptPremiumVisible = false
    })
  },
})

export const { showHighCandidateEngagementPro, showSecondJobAttemptPremium } =
  engagementPromoSlice.actions
export const selectHighCandidateEngagementProVisible = (state) =>
  state.engagementPromo.highCandidateEngagementProVisible
export const selectSecondJobAttemptPremiumVisible = (state) =>
  state.engagementPromo.secondJobAttemptPremiumVisible
export default engagementPromoSlice.reducer
